module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/my/card_2.png";